import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'
import { AircraftRouter } from './aircraft/_router'
import { AircraftConfigurationRouter } from './aircraft-configuration/_router'
import { AircraftTypeRouter } from './aircraft-type/_router'
import { AirportRouter } from './airport/_router'
import { CountryRouter } from './country/_router'
import { CountryInternalFlightVATRateRouter } from './country-internal-flight-vat-rate/_router'
import { CrewDailyAllowanceRouter } from './crew-daily-allowance/_router'
import { DispatchSettingsRouter } from './dispatch/_router'
import { EmailTemplateTesterRouter } from './email-template-tester/_router'
import { ExactRouter } from './exact/_router'
import { ExactVATCodeRouter } from './exact-vat-code/_router'
import { ExpenseCategoryRouter } from './expense-category/_router'
import { ExpenseCategoryConfigurationRouter } from './expense-category-configuration/_router'
import { FuelCostReferenceRouter } from './fuel-cost-reference/_router'
import { LabelSettingRouter } from './label-setting/_router'
import { MailInboxesRouter } from './mail-inboxes/_router'
import { MailSendersRouter } from './mail-senders/_router'
import { MdmRouter } from './mdm/_router'
import { MemberQuotaSettingsRouter } from './member-quota/_router'
import { MobileFeatureFlagsRouter } from './mobile-feature-flags/_router'
import { PaymentConditionRouter } from './payment-condition/_router'
import { PeppolRouter } from './peppol/_router'
import { PontoRouter } from './ponto/_router'
import { RoleRouter } from './role/_router'
import { SkylegsRouter } from './skylegs/_router'
import { SupplierCategoryRuleRouter } from './supplier-category-rule/_router'
import { SupplierCreationRequestsRouter } from './supplier-creation-requests/_router'
import { VaultRouter } from './vault/_router'

const Index = lazy(() => import('./Index'))

export const SettingsRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--settings']}>
    <Route index element={<Index />} />
    <Route path='aircraft/*' element={<AircraftRouter />} />
    <Route path='aircraft-configuration/*' element={<AircraftConfigurationRouter />} />
    <Route path='aircraft-type/*' element={<AircraftTypeRouter />} />
    <Route path='airport/*' element={<AirportRouter />} />
    <Route path='country/*' element={<CountryRouter />} />
    <Route
      path='country-internal-flight-vat-rate/*'
      element={<CountryInternalFlightVATRateRouter />}
    />
    <Route path='crew-daily-allowance/*' element={<CrewDailyAllowanceRouter />} />
    <Route path='dispatch/*' element={<DispatchSettingsRouter />} />
    <Route path='email-template-tester/*' element={<EmailTemplateTesterRouter />} />
    <Route path='exact/*' element={<ExactRouter />} />
    <Route path='exact-vat-code/*' element={<ExactVATCodeRouter />} />
    <Route path='expense-category/*' element={<ExpenseCategoryRouter />} />
    <Route
      path='expense-category-configuration/*'
      element={<ExpenseCategoryConfigurationRouter />}
    />
    <Route path='fuel-cost-reference/*' element={<FuelCostReferenceRouter />} />
    <Route path='label-setting/*' element={<LabelSettingRouter />} />
    <Route path='mail-inboxes/*' element={<MailInboxesRouter />} />
    <Route path='mail-senders/*' element={<MailSendersRouter />} />
    <Route path='mdm/*' element={<MdmRouter />} />
    <Route path='member-quota/*' element={<MemberQuotaSettingsRouter />} />
    <Route path='mobile-feature-flags/*' element={<MobileFeatureFlagsRouter />} />
    <Route path='payment-condition/*' element={<PaymentConditionRouter />} />
    <Route path='role/*' element={<RoleRouter />} />
    <Route path='peppol/*' element={<PeppolRouter />} />
    <Route path='ponto/*' element={<PontoRouter />} />
    <Route path='skylegs/*' element={<SkylegsRouter />} />
    <Route path='supplier-category-rule/*' element={<SupplierCategoryRuleRouter />} />
    <Route path='supplier-creation-requests/*' element={<SupplierCreationRequestsRouter />} />
    <Route path='vault/*' element={<VaultRouter />} />
  </SubRouter>
))
